import React from "react"
import Router, { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import ReactSVG from 'react-svg'
import useTranslation from 'next-translate/useTranslation'
import { connect } from "react-redux"
import { getTextSearchMessage } from 'SRC/modules/vehicleParts/list/selectors/getTextSearchMessage'
import { getUrl } from 'SRC/modules/vehicleParts/utils/vehiclePartsUtils'

import translations from '../../../../../../public/data/translations.json'

const TextSearchMobile = ({ textSearchMessage, setActiveTab }) => {
	const [text, setText] = React.useState('')
	const { t, lang } = useTranslation('common')

	const locale = lang?.toUpperCase() || 'ME'

	const router = useRouter()

	React.useEffect(() => {
		if (router?.query?.['text-filter']) {
			setText(router.query['text-filter'])
		}
	}, [router?.query?.['text-filter']])

	const textValue = ''

	const submit = () => {
		if (!text) return
		console.log('submit', text)

		const urlFromValues = getUrl({ 'text-filter': text }, locale)
		console.log('urlFromValues', urlFromValues)
		const href = urlFromValues.href
		const as = urlFromValues.asUrl

		Router.push(href, as)
	}

	const className = textSearchMessage ? 'vehicle-parts-text-search vehicle-parts-text-search--error' : 'vehicle-parts-text-search'

	return (
		<>
			<form
				onSubmit={e => { e.preventDefault() }}
				className={className}
			>
				<input
					type='text'
					placeholder={t('vehiclePartsTextSearchMobilePlaceholder')}
					onChange={e => {
						const value = e.target.value

						setText(value)
					}}
					defaultValue={textValue}
					value={text}
					maxLength={50}
				/>

				<button className='ads-search__button' onClick={submit}>
					<i className='ogl-header-ico ico-pretraga-text-search-lupa ico' />
				</button>

			</form>

			{textSearchMessage && <div className='vehicle-parts-text-search__message'>{textSearchMessage}</div>}

			<div className='filter-buttons filter-buttons-mobile'>
				<button
					className={`filter-buttons-search filter-buttons-search__toggle`}
					onClick={() => {
						setActiveTab('filters')
					}}
					style={{
						marginTop: '1rem',
						position: 'absolute',
						left: 0,
						right: 0,
						bottom: '4rem',
						marginLeft: '0.25rem',
						marginRight: '0.25rem',
						borderRadius: 25,
						width: '98%',
						backgroundColor: '#fff',
						color: '#bbb',
						borderColor: '#ddd',
						fontSize: '1rem'
					}}
				>
					<ReactSVG
						src='/icons/pretraga-po-filterima.svg'
						beforeInjection={svg => {
							svg.setAttribute('style', 'width: 25px; height: 25px; margin-right: 10px;');
							svg.querySelectorAll('path').forEach(path => {
								path.setAttribute('fill', '#bbb')
							});
						}}
					/>
					<span style={{ textTransform: 'uppercase' }}>{t('Pretraga po filterima')}</span>
				</button>

				<button
					className={`filter-buttons-search`}
					style={{ borderRadius: 25 }}
					onClick={submit}
				>
					<i className='ogl-header-ico ico-pretraga-text-search-lupa ico' />
					<span style={{ textTransform: 'uppercase' }}>{t('Pretraži djelove')}</span>
				</button>
			</div>
		</>
	)
}


TextSearchMobile.propTypes = {
	textSearchMessage: PropTypes.string,
	setActiveTab: PropTypes.func
}

const mapStateToProps = (state) => ({
	textSearchMessage: getTextSearchMessage(state)
})

export default connect(mapStateToProps)(TextSearchMobile)
